import classNames from 'classnames';
import { FunctionComponent } from 'react';
import { PrimaryButtonProps } from './PrimaryButtonProps';

export const PrimaryButton: FunctionComponent<PrimaryButtonProps> = ({
  className,
  title,
  icon,
  disabled = false,
  onClick
}) => {
  return (
    <button
      className={classNames(
        'px-4 py-1 bg-tint rounded-lg border border-black border-opacity-20 ',
        disabled ? 'opacity-30 cursor-default' : 'hover-effect click-effect',
        className
      )}
      disabled={disabled}
      onClick={onClick}
    >
      <div className="h-stack justify-center text-white font-medium">
        {icon ? <img src={icon} /> : undefined}
        {title}
      </div>
    </button>
  );
};
